import React from 'react';
import styles from './Motability7ContactSection.module.scss';

const ContactSection = ({ contactSectionData }) => {
  // 从 Sitecore 数据中提取图片 URL，支持响应式图片
  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    // 优先使用 desktopImage，然后是 tabletImage，最后是 mobileImage
    return (
      imageField.fields.desktopImage?.value?.src ||
      imageField.fields.tabletImage?.value?.src ||
      imageField.fields.mobileImage?.value?.src ||
      ''
    );
  };

  const imageUrl = getImageUrl(contactSectionData?.image);
  const mobileImageUrl = getImageUrl(contactSectionData?.mobileImage);
  const text = contactSectionData?.text || {};
  const buttonLink = contactSectionData?.buttonLink?.value || '';
  const buttonUrl = contactSectionData?.buttonUrl?.value?.href || '';
  const isComingSoon = contactSectionData?.isComingSoon?.value || false;
  const isComingSoonText = contactSectionData?.isComingSoonText?.value || 'Coming soon';

  const handleButtonClick = () => {
    if (buttonUrl && !isComingSoon) {
      window.location.href = buttonUrl;
    }
  };

  return (
    <div className={styles.container} data-aos="fade-up">
      <div className={styles.wrapper}>
        {imageUrl && (
          <img src={imageUrl} alt="Hero background" className={styles.backgroundImage} />
        )}
        {mobileImageUrl && (
          <img
            src={mobileImageUrl}
            alt="Hero background"
            className={styles.backgroundImageMobile}
          />
        )}
        <div className={styles.container}>
          <div className={styles.containerText}>
            {text?.value && <div dangerouslySetInnerHTML={{ __html: text.value }} />}
          </div>
          <div className={styles.containerLink}>
            {isComingSoon ? (
              <button className={styles.comingSoon}>{isComingSoonText}</button>
            ) : (
              <button className={styles.pcButton} onClick={handleButtonClick}>
                {buttonLink}
              </button>
            )}
          </div>
        </div>
      </div>

      {isComingSoon ? (
        <button className={styles.comingSoonMobile}>{isComingSoonText}</button>
      ) : (
        <button className={styles.laptopButton} onClick={handleButtonClick}>
          {buttonLink}
        </button>
      )}
    </div>
  );
};

export default ContactSection;
